import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/jobsearch/icon-no-result.svg'
import _imports_1 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-536ad0ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#f3f3f3"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-jobsearch" }
const _hoisted_4 = { class: "p-jobsearch-inner" }
const _hoisted_5 = { class: "p-jobsearch-header" }
const _hoisted_6 = { class: "p-jobsearch-header_inner" }
const _hoisted_7 = { class: "p-jobsearch-tab" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-tab_item_inner" }, "紹介求人", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-jobsearch-tab_item __current" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-tab_item_inner" }, "公開求人")
], -1))
const _hoisted_10 = { class: "p-jobsearch-control" }
const _hoisted_11 = { class: "p-jobsearch-control_inner" }
const _hoisted_12 = { class: "p-jobsearch-control_count" }
const _hoisted_13 = { class: "p-jobsearch-control_count_highlight" }
const _hoisted_14 = {
  key: 0,
  class: "p-jobsearch-list"
}
const _hoisted_15 = { class: "p-jobsearch-list_no-result" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-list_no-result_heading" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "p-jobsearch-list_no-result_img",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "条件に一致する求人がありません")
], -1))
const _hoisted_17 = { class: "p-jobsearch-list_no-result_contents" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ほかの条件でも検索してみませんか？", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-btn_ico" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-btn_ico" }, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "p-jobsearch-list"
}
const _hoisted_22 = { class: "p-jobsearch-list_more" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "p-jobsearch-sub-sp" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "p-jobsearch-sub" }
const _hoisted_28 = { class: "p-jobsearch-sub_outline" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-jobsearch-sub_heading" }, "現在の検索条件", -1))
const _hoisted_30 = { class: "p-jobsearch-sub_content" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "p-jobsearch-sub_content_hl" }, "年収", -1))
const _hoisted_32 = { class: "p-jobsearch-sub_content_txt" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "p-jobsearch-sub_content_hl" }, "勤務地", -1))
const _hoisted_34 = { class: "p-jobsearch-sub_content_txt" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "p-jobsearch-sub_content_hl" }, "職種", -1))
const _hoisted_36 = { class: "p-jobsearch-sub_content_txt" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "p-jobsearch-sub_content_hl" }, "その他", -1))
const _hoisted_38 = { class: "p-jobsearch-sub_content_txt word_break" }
const _hoisted_39 = {
  key: 1,
  class: "p-jobsearch-sub_content_txt"
}
const _hoisted_40 = { class: "p-jobsearch-sub_buttons" }
const _hoisted_41 = { class: "p-jobsearch-btn __white __save" }
const _hoisted_42 = ["checked", "disabled"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-btn_ico" }, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-btn_txt" }, "条件保存", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-btn_ico" }, null, -1))
const _hoisted_46 = { class: "p-jobsearch-search_card" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-jobsearch-search_card_header_hl" }, "検索条件を変更する", -1))
const _hoisted_48 = { class: "p-jobsearch-search_card_body __no-footer js-tab-container" }
const _hoisted_49 = { class: "p-jobsearch-search_card_sub" }
const _hoisted_50 = { class: "p-jobsearch-search_tab" }
const _hoisted_51 = { class: "p-jobsearch-search_card_main" }
const _hoisted_52 = { class: "p-jobsearch-search_section __clm" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_section_inner" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "p-jobsearch-search_hl" }, "勤務地")
], -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_section_inner" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "p-jobsearch-search_btn js-modal-open-button",
    type: "button",
    "data-modal-target": "modalSearch2"
  }, "指定する")
], -1))
const _hoisted_55 = {
  key: 0,
  class: "p-jobsearch-search_data"
}
const _hoisted_56 = ["checked", "onChange"]
const _hoisted_57 = { class: "p-jobsearch-search_section __clm" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_section_inner" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "p-jobsearch-search_hl" }, "職種")
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_section_inner" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "p-jobsearch-search_btn js-modal-open-button",
    type: "button",
    "data-modal-target": "modalSearch3"
  }, "指定する")
], -1))
const _hoisted_60 = {
  key: 0,
  class: "p-jobsearch-search_data"
}
const _hoisted_61 = ["checked", "onChange"]
const _hoisted_62 = { class: "p-jobsearch-search_section __clm" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_section_inner" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "p-jobsearch-search_hl" }, "業種")
], -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_section_inner" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "p-jobsearch-search_btn js-modal-open-button",
    type: "button",
    "data-modal-target": "modalSearch4"
  }, "指定する")
], -1))
const _hoisted_65 = {
  key: 0,
  class: "p-jobsearch-search_data"
}
const _hoisted_66 = ["checked", "onChange"]
const _hoisted_67 = { class: "p-jobsearch-search_save" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "この条件を保存する", -1))
const _hoisted_69 = { class: "p-jobsearch-search_card_footer __overflow" }
const _hoisted_70 = {
  class: "p-jobsearch-search_search",
  type: "submit"
}
const _hoisted_71 = { class: "__number" }
const _hoisted_72 = {
  class: "p-jobsearch-search_second js-modal-container",
  id: "modalSearch2"
}
const _hoisted_73 = {
  class: "p-jobsearch-search_second js-modal-container",
  id: "modalSearch3"
}
const _hoisted_74 = {
  class: "p-jobsearch-search_second js-modal-container",
  id: "modalSearch4"
}
const _hoisted_75 = { class: "l-wrapper_nav" }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_78 = [
  _hoisted_77
]

import { RouterLink, useRoute, useRouter } from 'vue-router';
import { domHelperUtils } from '@/utils/domHelper';
// 検索条件
import Keyword from '@/components/Keyword.vue';
import AnnualIncome from '@/components/AnnualIncome.vue';
import Location from '@/components/Location.vue';
import Occupation from '@/components/Occupation.vue';
import Industry from '@/components/Industry.vue';
import OvertimeHours from '@/components/OvertimeHours.vue';
import RemoteWork from '@/components/RemoteWork.vue';
import SideJob from '@/components/SideJob.vue';
import WorkCnd from '@/components/WorkCnd.vue';
import JobDsc from '@/components/JobDsc.vue';
import { nextTick, onActivated, watch } from 'vue';
import { getJobSearchPublicService } from '@/api/services/trnOrderService';
import { TrnLikeMypageAddRequest, TrnOrderJobSearchPublicRequest, TrnSearchMyPageAddRequest } from '@/types/request';
import { useStore } from 'vuex';
import { JobSearchPublicCard } from '@/types';
import { postLikeMypageAdd } from '@/api/trnLikeMypageEndpoint';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import Loading from '@/components/Loading.vue';
import { addSerchMyPageService, DialogSearchSelectedData, getSerchMyPageService, JobSearchCardData, TrnSerchMyPageInfo } from '@/api/services/trnSerchMyPageService';

import JobSearchPublicListItem from '@/components/JobSearchPublicListItem.vue';
import JobSearchSearchSaved from '@/components/JobSearchSearchSaved.vue'; 

// 求人リストのダミーデータ
import { computed, ref } from 'vue';
import { DEFAULT_KEYWORD_FIELD, formatNumber, jobSearchUtils } from '@/utils/jobSearch';
import { getJobSearchListService } from '@/api/services/shintyokuService';
import { getMessageForInvalidOrders } from '@/utils/messageFormat';
import { getCareerInfoConditionSearchService } from '@/api/services/trnCareerService';
import _ from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'JobSearchPublicView',
  setup(__props) {


const EMPTY_SREACH_ALERT = '対象を選択してください。';

const isHideJobSearchTab = ref(true);
const isAction = ref(true);

// モーダルの表示状態を管理するリアクティブな変数
const isModalSearchOpen = ref(false);
// タブのアクティブ状態を管理するリアクティブな変数
const currentTab = ref('search-tab1'); // デフォルトは「求人を探す」タブ

const countByCondition = ref('0');
const isJobListLoaded = ref(false);
const savedScrollTop = ref(0);

// モーダルを閉じる関数
const closeModalSearch = () => {
  isModalSearchOpen.value = false;
  if (route.query.modal){
    router.replace({ query: {} });
  }
  document.body.style.overflow = '';
};

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

const openModalSearch = (tab = 'search-tab1') => {
  document.body.style.overflow = 'hidden';
  isModalSearchOpen.value = true;
  currentTab.value = tab;
  setTimeout(() => {
    searchContentInput.value!.scrollTop = 0;
  });
};

const route = useRoute();
const router = useRouter();
const store = useStore();
const totalCount = ref(0);
const jobSearchPublicParams = ref<TrnOrderJobSearchPublicRequest>({});
const submitedParams = ref<TrnOrderJobSearchPublicRequest>({});
const isLoadingMore = ref(false);
const saveSearchCondRef = ref<HTMLInputElement>();

const hasMore = ref(false);

// 求人リストのダミーデータ
const jobList = ref<JobSearchPublicCard[]>([]);
const isLoading = ref(true);
const isReloadSavedSearch = ref(false);
const isStopCount = ref(false);

// data binding for 求人を探す
const dialogSearchSelectedData = ref(_.cloneDeep(jobSearchUtils.defaultSearch));

const currentSearch = ref<JobSearchCardData>({...jobSearchUtils.defaultSearchCard});
const currentSearchAdd = ref<JobSearchCardData>({...jobSearchUtils.defaultSearchCard});

const disableSaveSearchCond = computed(() => {
  return currentSearch.value.isSaved 
    || !(currentSearch.value.annualIncome
      && currentSearch.value.location
      && currentSearch.value.occupation);
});

const isEmptySearchCond = computed(() => {
  return currentSearch.value.annualIncome === MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE
      && currentSearch.value.location === MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE
      && currentSearch.value.occupation === MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE
      && !currentSearch.value.other;
});

// search condition for smartphone
const spSearchCond = computed(() => {
  let income = currentSearch.value.annualIncome;
  if (income === MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE) {
    income = '';
  }
  let location = currentSearch.value.location;
  if (location === MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE) {
    location = '';
  }
  let occup = currentSearch.value.occupation;
  if (occup === MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE) {
    occup = '';
  }
  let conds = [
    income,
    location,
    occup,
    currentSearch.value.other,
  ].filter(cond => cond).join('｜');
  if (conds.length > 60) {
    conds = conds.substring(0, 60) + '...';
  }
  return conds.trim();
});

function clearFormSearch() {
  isStopCount.value = true;
  // reset dialogSearchSelectedData
  const displayLocationList = dialogSearchSelectedData.value
                            .location
                            .displayLocationList
                            .map(i => {
                              i.isChecked = false;
                              return i;
                            });
  const displayOccupList = dialogSearchSelectedData.value
                            .occupation
                            .displayOccupList
                            .map(i => {
                              i.isChecked = false;
                              return i;
                            });
  const displayIndustryList = dialogSearchSelectedData.value
                            .industry
                            .displayIndustryList
                            .map(i => {
                              i.isChecked = false;
                              return i;
                            });
  dialogSearchSelectedData.value = _.cloneDeep(jobSearchUtils.defaultSearch);
  dialogSearchSelectedData.value.location.displayLocationList = [...displayLocationList];
  dialogSearchSelectedData.value.occupation.displayOccupList = [...displayOccupList];
  dialogSearchSelectedData.value.industry.displayIndustryList = [...displayIndustryList];
  setTimeout(function(){
    isStopCount.value = false;
    submitFormSearch(true, false, true);
  }, 0);
}

async function submitFormSearch(isFromBeforeMount = false, isUpdateSearchCard = false, isCount = false) {
  if(isCount){
    countByCondition.value = '...';
  } else {
    isLoading.value = true;
  }

  // convert 0 to null
  const zeroToNull = (val: number | null | undefined) => val ? val : undefined;
  jobSearchPublicParams.value = {
    jobsearchOcupctg1id: dialogSearchSelectedData.value.occupation.jobsearchOcupctg1id,
    jobsearchOcupctg2id: dialogSearchSelectedData.value.occupation.jobsearchOcupctg2id,
    jobsearchOcupctg3id: dialogSearchSelectedData.value.occupation.jobsearchOcupctg3id,
    jobsearchIndsctgGroupId: dialogSearchSelectedData.value.industry.jobsearchIndsctgGroupId,
    jobsearchIndsctgId: dialogSearchSelectedData.value.industry.jobsearchIndsctgId,
    jobsearchAnualslryValue: zeroToNull(dialogSearchSelectedData.value.jobsearchAnualslry?.id),
    jobsearchFeaturesOrder: dialogSearchSelectedData.value.jobsearchFeaturesOrder,
    jobsearchKeyword: dialogSearchSelectedData.value.keyword,
    jobsearchFeatures: dialogSearchSelectedData.value.jobsearchFeatures,
    jobsearchAreaid: dialogSearchSelectedData.value.location.jobsearchAreaid,
    jobsearchPrefid: dialogSearchSelectedData.value.location.jobsearchPrefid,
    jobsearchCityid: dialogSearchSelectedData.value.location.jobsearchCityid,
    jobsearchPossibleOvertime: zeroToNull(dialogSearchSelectedData.value.jobsearchPossibleOvertime?.id),
    jobsearchRemotework: zeroToNull(dialogSearchSelectedData.value.jobsearchRemotework?.id),
    jobsearchSideBusiness: zeroToNull(dialogSearchSelectedData.value.jobsearchSideBusiness),
  };

  if (isUpdateSearchCard) {
    currentSearchAdd.value = await jobSearchUtils.setCurrentSearchInfo(store, dialogSearchSelectedData.value);
  }

  let isSaveSuccess = false;
  if (!isFromBeforeMount && dialogSearchSelectedData.value.isSaveSearchCondition) {
    isSaveSuccess = await saveCurrentSearchMypage(true);
    if(!isSaveSuccess){
      isLoading.value = false;
      currentSearch.value.isSaved = false;
      return;
    }
  }
  if (isUpdateSearchCard) {
    currentSearch.value = currentSearchAdd.value;
  }

  await loadJobList({isCount: isCount}, true);

  if (!isFromBeforeMount) {

    if (dialogSearchSelectedData.value.isSaveSearchCondition) {
      // uncheck この条件を保存する
      dialogSearchSelectedData.value.isSaveSearchCondition = false;
    } else {
      currentSearch.value.isSaved = false;
      if (saveSearchCondRef.value) {
        saveSearchCondRef.value.checked = false;
      }
    }

    // チェックされた勤務地、職種、業種のみを保持する。
    const checkedLoc = dialogSearchSelectedData.value.location
                        .displayLocationList
                        .filter(loc => loc.isChecked);
    const checkedOccup = dialogSearchSelectedData.value.occupation
                        .displayOccupList
                        .filter(occup => occup.isChecked);
    const checkedInd = dialogSearchSelectedData.value.industry
                        .displayIndustryList
                        .filter(ind => ind.isChecked);

    dialogSearchSelectedData.value.location.displayLocationList = checkedLoc;
    dialogSearchSelectedData.value.occupation.displayOccupList = checkedOccup;
    dialogSearchSelectedData.value.industry.displayIndustryList = checkedInd;

    // save state
    sessionStorage.setItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_PUBLIC_SEARCHCOND,
      JSON.stringify(dialogSearchSelectedData.value));
    // remove url query
    router.replace({ query: {}});
  }

  if(!isCount){
    isModalSearchOpen.value = false;
    isLoading.value = false;
    // remove body style
    document.body.style.overflow = '';
  }
}

async function saveCurrentSearchMypage(isForce = false) {
  if (disableSaveSearchCond.value && !isForce) {
    return false;
  }

  if (!isForce) {
    currentSearchAdd.value = {...currentSearch.value};
  }
  
  const isEmptyForm = currentSearchAdd.value.annualIncome === MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE
      && currentSearchAdd.value.location === MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE
      && currentSearchAdd.value.occupation === MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE
      && !currentSearchAdd.value.other;

  if (isEmptyForm) {
    await store.dispatch('toasts/appendTimeToast', {label: EMPTY_SREACH_ALERT});
    if (saveSearchCondRef.value) {
      saveSearchCondRef.value.checked = false;
    }
    return false;
  }

  // キーワード
  let keywordFirst = '';
  let keywordSecond = '';
  let keywordThird = '';
  switch (jobSearchPublicParams.value.jobsearchKeyword?.field) {
    case 'job_skills':
      keywordFirst = encodeURIComponent(jobSearchPublicParams.value.jobsearchKeyword?.value ?? '')
      break;
    case 'company_name':
      keywordSecond = encodeURIComponent(jobSearchPublicParams.value.jobsearchKeyword?.value ?? '')
      break;
    case 'job_description':
      keywordThird = encodeURIComponent(jobSearchPublicParams.value.jobsearchKeyword?.value ?? '')
      break;
    default:
      break;
  }

  // build the search content
  const serchContent = 'jobsearch_ocupctg1id=' + (jobSearchPublicParams.value.jobsearchOcupctg1id ?? '')
                + '&jobsearch_ocupctg2id=' + (jobSearchPublicParams.value.jobsearchOcupctg2id ?? '')
                + '&jobsearch_ocupctg3id=' + (jobSearchPublicParams.value.jobsearchOcupctg3id ?? '')
                + '&jobsearch_areaid=' + (jobSearchPublicParams.value.jobsearchAreaid ?? '')
                + '&jobsearch_prefid=' + (jobSearchPublicParams.value.jobsearchPrefid ?? '')
                + '&jobsearch_cityid=' + (jobSearchPublicParams.value.jobsearchCityid ?? '')
                + '&jobsearch_indsctggroupid=' + (jobSearchPublicParams.value.jobsearchIndsctgGroupId ?? '')
                + '&jobsearch_indsctgid=' + (jobSearchPublicParams.value.jobsearchIndsctgId ?? '')
                + '&jobsearch_anualslryvalue=' + (jobSearchPublicParams.value.jobsearchAnualslryValue ?? '')
                + '&jobsearch_features=' + (jobSearchPublicParams.value.jobsearchFeatures ?? '')
                + '&jobsearch_features_order=' + (jobSearchPublicParams.value.jobsearchFeaturesOrder ?? '')
                + '&jobsearch_keywordfirst=' + keywordFirst
                + '&jobsearch_keywordsecond=' + keywordSecond
                + '&jobsearch_keywordthird=' + keywordThird
                + '&jobsearch_possibleovertime=' + (jobSearchPublicParams.value.jobsearchPossibleOvertime ?? '')
                + '&jobsearch_remotework=' + (jobSearchPublicParams.value.jobsearchRemotework ?? '')
                + '&jobsearch_sidebusiness=' + (jobSearchPublicParams.value.jobsearchSideBusiness ?? '');
  const search: TrnSearchMyPageAddRequest = {
    serchContent: serchContent,
    serchName: currentSearchAdd.value?.other
  };
  try {
    const resultSave = await addSerchMyPageService(search);
    if(resultSave.responseFault && resultSave.responseFault.responseId && resultSave.responseFault.responseId.substring(0, 1) == "E"){
      if (saveSearchCondRef.value) {
        saveSearchCondRef.value.checked = false;
      }
      await store.dispatch('toasts/appendTimeToast', {label: resultSave.responseFault.responseMessage});
      return false;
    }
    currentSearchAdd.value.isSaved = true;
    sessionStorage.setItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_PUBLIC_SEARCHCARD, JSON.stringify(currentSearchAdd.value));
    await store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.JOB_SEARCH_PUBLIC_REGIST_DONE});
    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
}

async function showSavedSearches(){
  // Only reload when navigating from another tab to tab2
  if (currentTab.value != 'search-tab2') {
    isReloadSavedSearch.value = true;
  }
  currentTab.value = 'search-tab2';
}

const searchContentInput = ref<HTMLElement>();
const dialogSearchLocationRefreshKey = ref(0);
const dialogSearchOccupationRefreshKey = ref(0);
const dialogSearchIndustryRefreshKey = ref(0);
async function applySavedSearch(searchData: TrnSerchMyPageInfo){
  isStopCount.value = true;
  const serch = searchData.serchContentObj;
  if (serch) {
    const strToArray = (str?: string) => str ? str.split(',') : [];
    const strToNum = (str?: string) => {
      const num = parseInt(str ?? '');
      return isNaN(num) ? 0 : num;
    };
    dialogSearchLocationRefreshKey.value++;
    dialogSearchOccupationRefreshKey.value++;
    dialogSearchIndustryRefreshKey.value++;

    let keywordField = '';
    let keywordValue = '';
    if(serch.jobsearch_keywordsecond){
      keywordField = 'company_name';
      keywordValue = serch.jobsearch_keywordsecond;
    } else if(serch.jobsearch_keywordfirst){
      keywordField = 'job_skills';
      keywordValue = serch.jobsearch_keywordfirst;
    } else if(serch.jobsearch_keywordthird){
      keywordField = 'job_description';
      keywordValue = serch.jobsearch_keywordthird;
    }

    dialogSearchSelectedData.value = {
      keyword: {
        field: keywordField,
        value: keywordValue,
      },
      jobsearchAnualslry: {
        id: strToNum(serch.jobsearch_anualslryvalue),
        text: MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE
      },
      location: {
        jobsearchAreaid: strToArray(serch.jobsearch_areaid),
        jobsearchPrefid: strToArray(serch.jobsearch_prefid).map(j => strToNum(j)),
        jobsearchCityid: strToArray(serch.jobsearch_cityid).map(j => strToNum(j)),
        displayLocationList: []
      },
      occupation: {
        jobsearchOcupctg1id: strToArray(serch.jobsearch_ocupctg1id),
        jobsearchOcupctg2id: strToArray(serch.jobsearch_ocupctg2id),
        jobsearchOcupctg3id: strToArray(serch.jobsearch_ocupctg3id),
        displayOccupList: []
      },
      industry: {
        jobsearchIndsctgGroupId: strToArray(serch.jobsearch_indsctggroupid),
        jobsearchIndsctgId: strToArray(serch.jobsearch_indsctgid).map(j => strToNum(j)),
        displayIndustryList: [],
      },
      jobsearchPossibleOvertime: {
        id: strToNum(serch.jobsearch_possibleovertime),
        text: ''
      },
      jobsearchRemotework: {
        id: strToNum(serch.jobsearch_remotework),
        text: ''
      },
      jobsearchSideBusiness: strToNum(serch.jobsearch_sidebusiness),
      jobsearchFeatures: strToArray(serch.jobsearch_features).map(j => strToNum(j)),
      jobsearchFeaturesOrder: strToArray(serch.jobsearch_features_order).map(j => strToNum(j)),

      isSaveSearchCondition: false,
    };

    // switch to 求人を探す
    currentTab.value = 'search-tab1';
    setTimeout(() => {
      searchContentInput.value!.scrollTop = 0;
    });
  }
  await nextTick();
  setTimeout(function(){
    isStopCount.value = false;
    submitFormSearch(true, false, true);
  }, 0);
}

async function loadJobList(params?: TrnOrderJobSearchPublicRequest, isNewSearch = true){

  let submitParams;  

  if(!params?.isCount){
    if(isNewSearch) {
      submitedParams.value = jobSearchPublicParams.value;
    }
    submitParams = submitedParams.value;
  } else {
    jobSearchUtils.toggleDialogSearch('modalSearch', true);
    submitParams = jobSearchPublicParams.value;
  }

  const requestParams: TrnOrderJobSearchPublicRequest = {
    ...submitParams,
    ...(params || {}),
  };

  const orderPublicState = await getJobSearchPublicService(requestParams);
  const orderPublicList = orderPublicState.trnOrderList;

  if(!params?.isCount){
    if (isNewSearch) {
      jobList.value = orderPublicList;
    } else {
      jobList.value = [...jobList.value, ...orderPublicList];
    }
    totalCount.value = orderPublicState.totalCount;

    submitedParams.value.pageCursor = orderPublicState.pageCursor;
    hasMore.value = orderPublicState.hasMore;
  } else {
    countByCondition.value = formatNumber(orderPublicState.totalCount);
  }
  isLoadingMore.value = false;
  jobSearchUtils.toggleDialogSearch('modalSearch', false);
}

async function nextPage(){
  isLoadingMore.value = true;
  await loadJobList({isCount: false}, false);
}

/**
 * Updates the 'isLiked' property of a job in jobList by orderId.
 * @param id - The orderId of the job to update.
 * @param favorite - The new value for the isLiked property.
 */
const updateJobListAfterChangeFavorite = (id: string, favorite: boolean) => {
  jobList.value = jobList.value.map(item =>
    item.orderId === id ? { ...item, isLiked: favorite } : item
  );
};

/**
 * Formats a message when changing favorite fails for a job.
 * @param id - The orderId of the job.
 * @returns The formatted failure message string.
 */
const formatMessageChangeFavoriteFailure = (id: string): string => {
  // Find the job with the matching orderId
  const job = jobList.value.find(v => v.orderId === id);
  if (job) {
    // Prepare the orders array for message formatting
    const orders = [{
      orderId: Number(job.orderId),
      realClientName: job.companyName,
      positionName: job.jobTitle
    }];
    // Return the formatted message
    return getMessageForInvalidOrders(orders);
  }
  return '';
};

const updateJobFavorite = async (id: string | undefined, favorite: boolean) => {
  if (!id) return;
  isAction.value = false;
  const requestParams: TrnLikeMypageAddRequest = {
    orderId: Number(id),
    addLikeFlag: favorite ? 1 : 0
  };
  // 0 => false
  // 1 => true
  let res = await postLikeMypageAdd(requestParams);
  if (res.data.responseFault && res.data.responseFault.responseId !== 'N011') {
    if(res.data.detail && res.data.detail.ignoreOrderId != null){
      store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.IGNORED_ORDER_ERR_MESG_SINGLE + formatMessageChangeFavoriteFailure(id)});
    }else{
      store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.NO_ACCESS_RIGHTS + formatMessageChangeFavoriteFailure(id)});
    }
    isAction.value = true;
    return;
  }
  // Update JobList value after successfully updating the favorites.
  updateJobListAfterChangeFavorite(id, favorite);
  if(favorite){
    store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.FAVORITE_DONE});
  } else {
    store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.UN_FAVORITE_DONE});
  }
  isAction.value = true;
};

onActivated(async () => {
  isLoading.value = true;

  // Keep the page state when has back event
  const orderChange = store.getters['favorites/favorites'];

  // Keep the page state when has back event
  if(route.meta.isBack && isJobListLoaded.value) {
    if(orderChange.orderId) {
      applyFavoriteChangeByOrderId(orderChange.orderId, orderChange.isLike);
      await nextTick();
    }
    isLoading.value = false;

    if(orderChange.orderId) {
      await nextTick();
      window.scrollTo({ top: savedScrollTop.value, behavior: 'smooth' });
      await store.dispatch('favorites/clearFavorite');
    }

    return;
  }

  resetRefs();

  await store.dispatch('favorites/clearFavorite');

  await handleOnActive();
})

let oldIsSaveSearchCondition = dialogSearchSelectedData.value.isSaveSearchCondition;
watch(() => dialogSearchSelectedData.value, async (newValue) => {
  if (isLoading.value) return;
  if(oldIsSaveSearchCondition == newValue.isSaveSearchCondition && !isStopCount.value){
    submitFormSearch(true, false, true);
  }
  oldIsSaveSearchCondition = newValue.isSaveSearchCondition;
}, { deep: true });

const handleOnActive = async() => {
  const jsonSearchCond = sessionStorage.getItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_PUBLIC_SEARCHCOND);

  // Load default search condition
  const isEmptyCurrentSearchCond = !jsonSearchCond;
  if (isEmptyCurrentSearchCond) {
    await jobSearchUtils.loadDefaultSearchCondition(store, dialogSearchSelectedData.value);
    // load 現在の検索条件 for default
    dialogSearchLocationRefreshKey.value++;
    dialogSearchOccupationRefreshKey.value++;
    currentSearch.value = await jobSearchUtils.setCurrentSearchInfo(store, dialogSearchSelectedData.value);
  }

  isHideJobSearchTab.value = route.query.jobSearchCnt === '0';

  if (!isHideJobSearchTab.value) {
    const privateJobSearch = await getJobSearchListService({}, false);
    const privateJobTotalCount = privateJobSearch.totalCount;
    isHideJobSearchTab.value = !privateJobTotalCount;
  }

  try {
    // 現在の検索条件
    const currentSearchCond = JSON.parse(sessionStorage.getItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_PUBLIC_SEARCHCOND) || 'false');
    const currentSearchCard = JSON.parse(sessionStorage.getItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_PUBLIC_SEARCHCARD) || 'false');
    const searchCompanyKeyword = sessionStorage.getItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_PUBLIC_SEARCH_COMPANY);

    // init default
    if (currentSearchCond) {
      dialogSearchSelectedData.value = {
        ...currentSearchCond,
        isSaveSearchCondition: false,
      };
    }
    if (currentSearchCard) {
      currentSearch.value = {...currentSearchCard};
    }
    if (searchCompanyKeyword) {
      clearFormSearch();
      dialogSearchSelectedData.value.keyword = {
        field: DEFAULT_KEYWORD_FIELD,
        value: searchCompanyKeyword,
      };
    }

    // F_00 ホーム画面
    const isFromHome = store.getters['router/previousRoute']?.name === 'f00';
    const qSearchId = Number(route.query.searchId);
    // count for search
    await submitFormSearch(true, false, true);

    if (qSearchId) {
      const serch = await getSerchMyPageService(qSearchId);
      if (serch) {
        applySavedSearch(serch);
        await submitFormSearch(false, true);
        currentSearch.value = await jobSearchUtils.setCurrentSearchInfo(store, dialogSearchSelectedData.value);
      }
    } else if (searchCompanyKeyword) {
      await submitFormSearch(false, true);
    } else if (currentSearchCond && currentSearchCard){
      await submitFormSearch(true, isFromHome);
    } else {
      await submitFormSearch(true, false);
    }
    
    // reopen search modal
    const qModal = route.query.modal;
    const qTab = route.query.tab;
    if (qModal == 'modalSearch' && qTab == 'search-tab2') {
      openModalSearch(qTab);
      isReloadSavedSearch.value = true;
    }
    isJobListLoaded.value = true;
  } catch (error) {
    console.error(error);
    sessionStorage.removeItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_PUBLIC_SEARCHCOND);
    sessionStorage.removeItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_PUBLIC_SEARCHCARD);
  } finally {
    sessionStorage.removeItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_PUBLIC_SEARCH_COMPANY);

    isLoading.value = false;
    const query = {...route.query};
    delete query.jobSearchCnt;
    router.replace({query});
  }
}

function applyFavoriteChangeByOrderId(orderId: string, isLike: boolean) {
  const idx = getOrderIndexByOrderId(orderId);
  if (idx >= 0) {
    const updated = {
      ...jobList.value[idx],
      isLiked: isLike,
    };
    jobList.value[idx] = updated;
    jobList.value = [...jobList.value];
  }
}

function getOrderIndexByOrderId(orderId: string): number {
  return jobList.value.findIndex(j => String(j.orderId) === String(orderId));
}

const handleSaveScrollTop = () => {
  savedScrollTop.value = window.scrollY || window.pageYOffset || 0;
};

const resetRefs = () => {
  dialogSearchSelectedData.value = _.cloneDeep(jobSearchUtils.defaultSearch);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", _hoisted_3, [
          _withDirectives(_createElementVNode("form", {
            onSubmit: _cache[17] || (_cache[17] = _withModifiers(() => submitFormSearch(false, true), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (!isHideJobSearchTab.value)
                      ? (_openBlock(), _createBlock(_unref(RouterLink), {
                          key: 0,
                          class: "p-jobsearch-tab_item",
                          to: {name: 'h00'}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_9
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, [
                        _createTextVNode("全"),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(totalCount.value), 1),
                        _createTextVNode("件")
                      ]),
                      _createVNode(_unref(RouterLink), {
                        class: "p-jobsearch-control_link",
                        to: {name: 'm00'}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("応募しない求人一覧")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              (jobList.value.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("button", {
                          class: "p-jobsearch-btn __blue __search js-modal-open-button",
                          type: "button",
                          "data-modal-target": "modalSearch",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (openModalSearch()))
                        }, [
                          _hoisted_19,
                          _createTextVNode("条件を変更する "),
                          _hoisted_20
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (jobList.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobList.value, (job) => {
                      return (_openBlock(), _createBlock(JobSearchPublicListItem, {
                        key: job.orderId,
                        job: job,
                        "is-bulk-selection-enabled": false,
                        "is-after-apply": job.isApply && !job.isRefusal,
                        "onUpdate:favorite": favorite => updateJobFavorite(job.orderId, favorite),
                        onSaveScrollTop: handleSaveScrollTop,
                        screenName: "public"
                      }, null, 8, ["job", "is-after-apply", "onUpdate:favorite"]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_22, [
                      (hasMore.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            disabled: isLoadingMore.value,
                            class: "p-jobsearch-btn __blue __more",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (nextPage()))
                          }, [
                            _createTextVNode(" 検索結果をもっと見る"),
                            _createElementVNode("span", {
                              class: _normalizeClass(["p-jobsearch-btn_ico", {'loading-spinner': isLoadingMore.value}])
                            }, null, 2)
                          ], 8, _hoisted_23))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_24, [
                (!_unref(isEmptySearchCond))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_unref(spSearchCond)), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_26, "検索条件が設定されていません"))
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("dl", _hoisted_30, [
                    (!_unref(isEmptySearchCond))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_31,
                          _createElementVNode("dd", _hoisted_32, _toDisplayString(currentSearch.value.annualIncome), 1),
                          _hoisted_33,
                          _createElementVNode("dd", _hoisted_34, _toDisplayString(currentSearch.value.location), 1),
                          _hoisted_35,
                          _createElementVNode("dd", _hoisted_36, _toDisplayString(currentSearch.value.occupation), 1),
                          _hoisted_37,
                          _createElementVNode("dd", _hoisted_38, _toDisplayString(currentSearch.value.other), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock("dd", _hoisted_39, "検索条件が設定されていません"))
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      ref_key: "saveSearchCondRef",
                      ref: saveSearchCondRef,
                      checked: _unref(disableSaveSearchCond),
                      disabled: _unref(disableSaveSearchCond),
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (saveCurrentSearchMypage()))
                    }, null, 40, _hoisted_42),
                    _hoisted_43,
                    _hoisted_44
                  ]),
                  _createElementVNode("button", {
                    class: "p-jobsearch-btn __blue __setting js-modal-open-button",
                    type: "button",
                    "data-modal-target": "modalSearch",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (openModalSearch()))
                  }, [
                    _hoisted_45,
                    _createTextVNode("この条件を変更する ")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["p-jobsearch-search js-modal-container", { 'is-active': isModalSearchOpen.value }]),
              id: "modalSearch"
            }, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", { class: "p-jobsearch-search_card_header" }, [
                  _hoisted_47,
                  _createElementVNode("button", {
                    class: "p-jobsearch-search_card_header_close",
                    type: "button",
                    onClick: closeModalSearch
                  }, "閉じる")
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["p-jobsearch-search_tab_item js-tab-btn", { '__current': currentTab.value === 'search-tab1' }]),
                        "data-tab": "search-tab1",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (currentTab.value = 'search-tab1'))
                      }, " 求人を探す ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["p-jobsearch-search_tab_item js-tab-btn", { '__current': currentTab.value === 'search-tab2' }]),
                        "data-tab": "search-tab2",
                        onClick: showSavedSearches
                      }, " 保存した条件 ", 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["p-jobsearch-search_tab-content __wp js-tab-target", { '__current': currentTab.value === 'search-tab1' }]),
                      id: "search-tab1"
                    }, [
                      _createElementVNode("div", {
                        class: "p-jobsearch-search_content __has-footer",
                        ref_key: "searchContentInput",
                        ref: searchContentInput
                      }, [
                        _createVNode(Keyword, {
                          "model-value": dialogSearchSelectedData.value.keyword,
                          "onUpdate:model-value": _cache[5] || (_cache[5] = ($event: any) => ((dialogSearchSelectedData.value.keyword) = $event))
                        }, null, 8, ["model-value"]),
                        _createVNode(AnnualIncome, {
                          "model-value": dialogSearchSelectedData.value.jobsearchAnualslry,
                          "onUpdate:model-value": _cache[6] || (_cache[6] = ($event: any) => ((dialogSearchSelectedData.value.jobsearchAnualslry) = $event))
                        }, null, 8, ["model-value"]),
                        _createElementVNode("div", _hoisted_52, [
                          _hoisted_53,
                          _hoisted_54,
                          (dialogSearchSelectedData.value.location.displayLocationList.length)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_55, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogSearchSelectedData.value.location.displayLocationList, (chk) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: chk.id,
                                    class: "p-jobsearch-search_data_item"
                                  }, [
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        checked: chk.isChecked,
                                        onChange: ($event: any) => (_unref(jobSearchUtils).updateLocationSearchData(dialogSearchSelectedData.value, chk, ($event.target as HTMLInputElement).checked))
                                      }, null, 40, _hoisted_56),
                                      _createElementVNode("span", null, _toDisplayString(chk.text), 1)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _hoisted_58,
                          _hoisted_59,
                          (dialogSearchSelectedData.value.occupation.displayOccupList.length)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_60, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogSearchSelectedData.value.occupation.displayOccupList, (chk) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: chk.id,
                                    class: "p-jobsearch-search_data_item"
                                  }, [
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        checked: chk.isChecked,
                                        onChange: ($event: any) => (_unref(jobSearchUtils).updateOccupationSearchData(dialogSearchSelectedData.value, chk, ($event.target as HTMLInputElement).checked))
                                      }, null, 40, _hoisted_61),
                                      _createElementVNode("span", null, _toDisplayString(chk.text), 1)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _hoisted_63,
                          _hoisted_64,
                          (dialogSearchSelectedData.value.industry.displayIndustryList.length)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_65, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogSearchSelectedData.value.industry.displayIndustryList, (chk) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: chk.id,
                                    class: "p-jobsearch-search_data_item"
                                  }, [
                                    _createElementVNode("label", null, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        checked: chk.isChecked,
                                        onChange: ($event: any) => (_unref(jobSearchUtils).updateIndustrySearchData(dialogSearchSelectedData.value, chk, ($event.target as HTMLInputElement).checked))
                                      }, null, 40, _hoisted_66),
                                      _createElementVNode("span", null, _toDisplayString(chk.text), 1)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(OvertimeHours, {
                          "model-value": dialogSearchSelectedData.value.jobsearchPossibleOvertime,
                          "onUpdate:model-value": _cache[7] || (_cache[7] = ($event: any) => ((dialogSearchSelectedData.value.jobsearchPossibleOvertime) = $event))
                        }, null, 8, ["model-value"]),
                        _createVNode(RemoteWork, {
                          "model-value": dialogSearchSelectedData.value.jobsearchRemotework,
                          "onUpdate:model-value": _cache[8] || (_cache[8] = ($event: any) => ((dialogSearchSelectedData.value.jobsearchRemotework) = $event))
                        }, null, 8, ["model-value"]),
                        _createVNode(SideJob, {
                          "model-value": dialogSearchSelectedData.value.jobsearchSideBusiness,
                          "onUpdate:model-value": _cache[9] || (_cache[9] = ($event: any) => ((dialogSearchSelectedData.value.jobsearchSideBusiness) = $event))
                        }, null, 8, ["model-value"]),
                        _createVNode(WorkCnd, {
                          "selected-values": dialogSearchSelectedData.value.jobsearchFeatures,
                          "onUpdate:selected-values": _cache[10] || (_cache[10] = ($event: any) => ((dialogSearchSelectedData.value.jobsearchFeatures) = $event))
                        }, null, 8, ["selected-values"]),
                        _createVNode(JobDsc, {
                          "selected-values": dialogSearchSelectedData.value.jobsearchFeaturesOrder,
                          "onUpdate:selected-values": _cache[11] || (_cache[11] = ($event: any) => ((dialogSearchSelectedData.value.jobsearchFeaturesOrder) = $event))
                        }, null, 8, ["selected-values"]),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dialogSearchSelectedData.value.isSaveSearchCondition) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, dialogSearchSelectedData.value.isSaveSearchCondition]
                            ]),
                            _hoisted_68
                          ])
                        ])
                      ], 512),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("button", {
                          class: "p-jobsearch-search_clear",
                          id: "clearModalSearch",
                          type: "button",
                          onClick: clearFormSearch
                        }, "条件をクリア"),
                        _createElementVNode("button", _hoisted_70, [
                          _createElementVNode("span", null, [
                            _createTextVNode("検索する"),
                            _createElementVNode("span", _hoisted_71, "（" + _toDisplayString(countByCondition.value) + "件）", 1)
                          ])
                        ])
                      ])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["p-jobsearch-search_tab-content __wp js-tab-target", { '__current': currentTab.value === 'search-tab2' }]),
                      id: "search-tab2"
                    }, [
                      _createVNode(JobSearchSearchSaved, {
                        "reload-saved-searches": isReloadSavedSearch.value,
                        onRefreshed: _cache[13] || (_cache[13] = () => isReloadSavedSearch.value = false),
                        onApplySavedSearch: applySavedSearch
                      }, null, 8, ["reload-saved-searches"])
                    ], 2)
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["p-jobsearch-search_bg", { 'is-active': isModalSearchOpen.value }]),
                onClick: closeModalSearch
              }, null, 2)
            ], 2),
            _createElementVNode("div", _hoisted_72, [
              _createVNode(Location, {
                "selected-locations": dialogSearchSelectedData.value.location,
                "onUpdate:selected-locations": _cache[14] || (_cache[14] = ($event: any) => ((dialogSearchSelectedData.value.location) = $event)),
                "refresh-key": dialogSearchLocationRefreshKey.value
              }, null, 8, ["selected-locations", "refresh-key"])
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createVNode(Occupation, {
                "selected-occupations": dialogSearchSelectedData.value.occupation,
                "onUpdate:selected-occupations": _cache[15] || (_cache[15] = ($event: any) => ((dialogSearchSelectedData.value.occupation) = $event)),
                "refresh-key": dialogSearchOccupationRefreshKey.value
              }, null, 8, ["selected-occupations", "refresh-key"])
            ]),
            _createElementVNode("div", _hoisted_74, [
              _createVNode(Industry, {
                "selected-industries": dialogSearchSelectedData.value.industry,
                "onUpdate:selected-industries": _cache[16] || (_cache[16] = ($event: any) => ((dialogSearchSelectedData.value.industry) = $event)),
                "refresh-key": dialogSearchIndustryRefreshKey.value
              }, null, 8, ["selected-industries", "refresh-key"])
            ])
          ], 544), [
            [_vShow, !isLoading.value]
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_75, [
        _createElementVNode("a", {
          class: "g-pagetop",
          href: "#",
          onClick: _withModifiers(scrollToTop, ["prevent"]),
          "aria-label": "ページトップへ戻る"
        }, _hoisted_78, 8, _hoisted_76)
      ], 512), [
        [_vShow, !isLoading.value]
      ])
    ]),
    _createVNode(Loading, {
      "is-loading": isLoading.value || !isAction.value
    }, null, 8, ["is-loading"])
  ], 64))
}
}

})